import { gql } from '@apollo/client';

export const ALL_CURRENCIES_QUERY_NAME = 'AllCurrencies';
export const ALL_CURRENCIES = gql`
    query ${ALL_CURRENCIES_QUERY_NAME}(
        $page: Int,
        $perPage: Int,
        $sortKey: String,
        $sortDirection: String,
        $includeDeactivated: Boolean,
        $valueMapping: Map_String_List_MappedValueScalar,
    ) {
        allCurrencies(
            page: $page,
            perPage: $perPage,
            sortKey: $sortKey,
            sortDirection: $sortDirection,
            includeDeactivated: $includeDeactivated,
            valueMapping: $valueMapping,
        ) {
            totalCount
            models {
                name
                code
                exchangeRate
                active
                deactivationBlockers
                modificationBlockers
            }
        }
    }
`;

export const UPDATE_CURRENCY = gql`
    mutation UpdateCurrency(
        $code: String!, 
        $name: String!, 
        $exchangeRate: ExchangeRate!, 
        $correlationId: String!
    ) {
        updateCurrency(
            code: $code, 
            name: $name, 
            exchangeRate: $exchangeRate, 
            correlationId: $correlationId
        ) {
            name
            code
        }
    }
`;

export const CREATE_CURRENCY = gql`
    mutation CreateCurrency(
        $code: String!, 
        $name: String!, 
        $exchangeRate: ExchangeRate!, 
        $correlationId: String!
    ) {
        createCurrency(
            code: $code, 
            name: $name, 
            exchangeRate: $exchangeRate, 
            correlationId: $correlationId
        ) {
            name
            code
        }
    }
`;

export const ON_CURRENCY_CHANGED = gql`
    subscription onCurrencyChanged {
        currencyChanged {
            correlationId
            action
            model {
                totalCount
                models {
                    name
                    code
                }
            }
        }
    }
`;

export const TOGGLE_CURRENCY_ACTIVATION = gql`
    mutation ToggleCurrencyActivation(
        $code: String!,
        $correlationId: String!,
    ) {
        toggleCurrencyActivation(
            code: $code,
            correlationId: $correlationId,
        ) {
            name
            code
            active
        }
    }
`;
